import { ApolloLink } from 'apollo-link';
import { flags, getFlag } from 'services/developer';
import { Logger } from 'services';

export const monitorLink = new ApolloLink((operation, forward) => {
  return forward(operation).map((result) => {
    if (getFlag(flags.MonitorGraphQLResponses)) {
      Logger.info(operation, result);
    }
    return result;
  });
});

export const monitorAnalyticsLink = new ApolloLink((operation, forward) => {
  return forward(operation).map((result) => {
    if (getFlag(flags.MonitorAnalyticsRequests)) {
      Logger.info('Analytics request:', operation, result);
    }
    return result;
  });
});
